module.exports = __webpack_public_path__ + "img/cancel.bc866895.png";